import React, { useState, useRef, useEffect, useContext } from "react";
import MyContext from "../context/MyContext";
import Chrome from "react-color";

function SmartColorPicker(props, charJSON) {
  const [AdvanceColors, setAdvanceColors] = useState(false);

  const [ChrColorPicker, setChrColorPicker] = useState(false);

  const [left, setleft] = useState(0);

  const [rgba, setrgba] = useState([]);

  const [ShadeName, setShadeName] = useState("");

  const [openColorPickerBox, setOpenColorPickerBox] = useState(false);

  const focusDiv = useRef(null);

  const {
    characterEditor,
    setCharacterEditor,
    LayersData,
    setLayersData,
    characterId,
  } = useContext(MyContext);

  useEffect(() => {
    //alert(charJSON);
  }, []);

  const [SkinDefaultColors, setSkinDefaultColors] = useState([
    { color: "#E6BCA6" },
    { color: "#f1c27d" },
    { color: "#e0ac69" },
    { color: "#c68642" },
    { color: "#8d5524" },
    { color: "#592f2a" },
    { color: "#ffe0bd" },
    { color: "#ffcd94" },
    { color: "#eac086" },
    { color: "#ffe39f" },
    { color: "#ffad60" },
    { color: "#fe9430" },
    { color: "#c58c85" },
    { color: "#5dd5a5" },
    { color: "#4fa7ff" },
    { color: "#7181ca" },
    { color: "#ff5e99" },
    { color: "#676571" },
  ]);

  var DefaultColors = [
    { color: "#ffffff" },
    { color: "#F7D6B7" },
    { color: "#007bff" },
    { color: "#ffc107" },
    { color: "#28a745" },
    { color: "#17a2b8" },
    { color: "#f44336" },
    { color: "#e91e63" },
    { color: "#9c27b0" },
    { color: "#673ab7" },
    { color: "#3f51b5" },
    { color: "#03a9f4" },
    { color: "#ff9800" },
    { color: "#795548" },
    { color: "#9e9e9e" },
    { color: "#607d8b" },
    { color: "#009688" },
    { color: "#343a40" },
  ];

  const openpicker = (params, name, r, g, b) => {
    var targetleft = params.target.getBoundingClientRect().x;

    var parentLeft =
      params.target.offsetParent.offsetParent.getBoundingClientRect().x;

    //left = Math.round(targetleft) - Math.round(parentLeft) - 26

    setChrColorPicker(true);

    setleft(Math.round(targetleft) - Math.round(parentLeft) - 26);

    setrgba("rgb(" + r + "," + g + "," + b + ")");

    setAdvanceColors(false);

    setShadeName(name);
  };

  const setTieColor = (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Shirt") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Tie_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
        break;
      }
    }
  };

  const setShirtColor = (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Shirt") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Shirt_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "ForeArm_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Shirt_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "ForeArm_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Shirt_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Arm_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Shirt_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Arm_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Shirt_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }

          //console.log(skins.it[2].c);
        }
      }
    }
  };

  const setMiddleShirtColor = (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Middle") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Middle_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "ForeArm_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Middle_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "ForeArm_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Middle_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Arm_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Middle_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Arm_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Middle_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }

          //console.log(skins.it[2].c);
        }
      }
    }
  };

  const setSkinColor = async (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Face") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "EyeShut1") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.find(
            (el) => el.nm == "Skin_ID"
          );
          for (var it = 0; it < skins.it.length; it++) {
            if (skins.it[it].ty === "fl") {
              skins.it[it].c.k[0] = rgba[0].trim() / 25 / 10;
              skins.it[it].c.k[1] = rgba[1].trim() / 25 / 10;
              skins.it[it].c.k[2] = rgba[2].trim() / 25 / 10;
            }
          }
        }
      } else if (name == "EyeShut2") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.find(
            (el) => el.nm == "Skin_ID"
          );
          for (var it = 0; it < skins.it.length; it++) {
            if (skins.it[it].ty === "fl") {
              skins.it[it].c.k[0] = rgba[0].trim() / 25 / 10;
              skins.it[it].c.k[1] = rgba[1].trim() / 25 / 10;
              skins.it[it].c.k[2] = rgba[2].trim() / 25 / 10;
            }
          }
        }
      } else if (name == "Body") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.find(
            (el) => el.nm == "Skin_ID"
          );
          for (var it = 0; it < skins.it.length; it++) {
            if (skins.it[it].ty === "fl") {
              skins.it[it].c.k[0] = rgba[0].trim() / 25 / 10;
              skins.it[it].c.k[1] = rgba[1].trim() / 25 / 10;
              skins.it[it].c.k[2] = rgba[2].trim() / 25 / 10;
            }
          }
        }
      } else if (name == "Hand_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.find(
            (el) => el.nm == "Skin_ID"
          );
          if (skins != undefined) {
            for (var it = 0; it < skins.it.length; it++) {
              if (skins.it[it].ty === "fl") {
                skins.it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins.it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins.it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
        }
      } else if (name == "Hand_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.find(
            (el) => el.nm == "Skin_ID"
          );
          if (skins != undefined) {
            for (var it = 0; it < skins.it.length; it++) {
              if (skins.it[it].ty === "fl") {
                skins.it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins.it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins.it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
        }
      } else if (name == "Eye") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Neck") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Ear_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Ear_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      
      else if (name == "Arm_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      else if (name == "Arm_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }
      else if (name == "ForeArm_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      else if (name == "ForeArm_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }
    }
  };

  const setHairColor = (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Hair") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Hair_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }
      if (name == "Hair1") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Hair1_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }
    }
  };

  const setEyeColor = (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Eye") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Eye_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
        break;
      }
    }
  };

  const setEyeBro = (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "EyeBro") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm.trim() == "EyeBro_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }
      if (name == "Eye") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm.trim() == "EyeBro_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }
    }
  };

  const setGlassesColor = (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Glasses") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm.trim() == "Glasses_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
        break;
      }
    }
  };

  const setCapColor = (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Cap") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm.trim() == "Cap_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
        break;
      }
    }
  };

  const setBottomColor = (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Hip") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Bottom_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Leg_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Bottom_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Leg_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Bottom_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Calf_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Bottom_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Calf_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Bottom_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }
    }
  };

  const setShoeColor = (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Shoe_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm.trim() == "Shoe1_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }

          // skins = json.assets[0].layers[Layr].shapes.filter(
          //   (el) => el.nm.trim() == "Shoe2_ID"
          // );
          // for (var skn = 0; skn < skins.length; skn++) {
          //   for (var it = 0; it < skins[skn].it.length; it++) {
          //     if (skins[skn].it[it].ty === "fl") {
          //       skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
          //       skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
          //       skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
          //     }
          //   }
          // }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Shoe_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm.trim() == "Shoe1_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }

          // skins = json.layers[0].layers[Layr].shapes.filter(
          //   (el) => el.nm.trim() == "Shoe2_ID"
          // );
          // for (var skn = 0; skn < skins.length; skn++) {
          //   for (var it = 0; it < skins[skn].it.length; it++) {
          //     if (skins[skn].it[it].ty === "fl") {
          //       skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
          //       skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
          //       skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
          //     }
          //   }
          // }
          //console.log(skins.it[2].c);
        }
      }
    }
  };

  const setBeard = (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Beard") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Beard_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }
    }
  };

  const setMustache = (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Mustache") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Mustache_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }
    }
  };

  const setMaskColor = (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Mask") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Mask_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }
    }
  };

  const setCoatColor = (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Coat") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Coat_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }
      if (name == "ForeArm_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Coat_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "ForeArm_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Coat_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "Arm_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Coat_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "Arm_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Coat_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }
    }
  };

  return (
    <>
      <div className="charClrBox" style={{ padding: "5px" }}>
        <div
          onClick={(e) => {
            //setSkinColor(array[i].JSONValue, rgba);
            //setLayersData(array);
            setOpenColorPickerBox(true);
          }}
          id={props.value.name}
          className="charClrBoxInner"
          style={{
            background:
              "rgba(" +
              props.rgb[0] * 25 * 10 +
              "," +
              props.rgb[1] * 25 * 10 +
              "," +
              props.rgb[2] * 25 * 10 +
              ",1)",
          }}
        ></div>
      </div>
      {openColorPickerBox && (
        <div
          ref={focusDiv}
          tabIndex="1"
          style={{ position: "absolute", bottom: "4px", left: "4px" }}
        >
          <div className="OptPopContainer2">
            <div className="OptInner2">
              <div className="boxUpper2">
                <div className="popTitle">Basic Colors</div>

                <span
                  className="material-icons"
                  style={{ padding: "3px 0px", cursor: "pointer" }}
                  onClick={() => {
                    setOpenColorPickerBox(false);
                  }}
                >
                  close
                </span>
              </div>

              <div className="boxBottom">
                <div className="defaultColorsUpper">
                  <div className="defaultColors">
                    {props.value != undefined &&
                      props.value.name === "Skin" &&
                      SkinDefaultColors.map((lmc, index) => (
                        <div
                          onClick={(e) => {
                            var rgb = e.target.attributes.style.value
                              .split("(")[1]
                              .split(")")[0]
                              .split(",");
                            // props.AllUpdatedGesturesJSON.map((item) => {
                            //   (async () => {
                            //     const resp = await fetch(item);
                            //     const jsonData = await resp.json();
                            //     await setSkinColor(jsonData, rgb);
                            //   })();
                            // });
                            localStorage.setItem("SkinColor", rgb);
                            var json = props.charJSON;
                            setSkinColor(json, rgb);
                            props.setCurrentJSON({
                              ...props.charJSON,
                              json,
                            });
                            setOpenColorPickerBox(false);
                          }}
                          style={{ backgroundColor: lmc.color }}
                        >
                          <div
                            className="defaultColorsBlock"
                            style={{ visibility: "hidden" }}
                          >
                            abc
                          </div>
                        </div>
                      ))}

                    {props.value != undefined &&
                      props.value.name === "Hair" &&
                      SkinDefaultColors.map((lmc, index) => (
                        <div
                          onClick={(e) => {
                            //alert(e.target.attributes.style.value);
                            var rgb = e.target.attributes.style.value
                              .split("(")[1]
                              .split(")")[0]
                              .split(",");
                            localStorage.setItem("HairColor", rgb);
                            var json = props.charJSON;
                            setHairColor(json, rgb);
                            props.setCurrentJSON({
                              ...props.charJSON,
                              json,
                            });
                            setOpenColorPickerBox(false);
                          }}
                          style={{ backgroundColor: lmc.color }}
                        >
                          <div
                            className="defaultColorsBlock"
                            style={{ visibility: "hidden" }}
                          >
                            abc
                          </div>
                        </div>
                      ))}

                    {props.value != undefined &&
                      props.value.name === "Tie" &&
                      DefaultColors.map((lmc, index) => (
                        <div
                          onClick={(e) => {
                            var rgb = e.target.attributes.style.value
                              .split("(")[1]
                              .split(")")[0]
                              .split(",");
                            var json = props.charJSON;
                            localStorage.setItem("TieColor", rgb);
                            setTieColor(json, rgb);
                            props.setCurrentJSON({
                              ...props.charJSON,
                              json,
                            });
                            setOpenColorPickerBox(false);
                          }}
                          style={{ backgroundColor: lmc.color }}
                        >
                          <div
                            className="defaultColorsBlock"
                            style={{ visibility: "hidden" }}
                          >
                            abc
                          </div>
                        </div>
                      ))}

                    {props.value != undefined &&
                      props.value.name === "Eye" &&
                      SkinDefaultColors.map((lmc, index) => (
                        <div
                          onClick={(e) => {
                            var rgb = e.target.attributes.style.value
                              .split("(")[1]
                              .split(")")[0]
                              .split(",");
                            var json = props.charJSON;
                            localStorage.setItem("EyeColor", rgb);
                            setEyeColor(json, rgb);
                            props.setCurrentJSON({
                              ...props.charJSON,
                              json,
                            });
                            setOpenColorPickerBox(false);
                          }}
                          style={{ backgroundColor: lmc.color }}
                        >
                          <div
                            className="defaultColorsBlock"
                            style={{ visibility: "hidden" }}
                          >
                            abc
                          </div>
                        </div>
                      ))}

                    {props.value != undefined &&
                      props.value.name === "Shirt" &&
                      DefaultColors.map((lmc, index) => (
                        <div
                          onClick={(e) => {
                            var rgb = e.target.attributes.style.value
                              .split("(")[1]
                              .split(")")[0]
                              .split(",");
                            var json = props.charJSON;
                            localStorage.setItem("ShirtColor", rgb);
                            setShirtColor(json, rgb);
                            props.setCurrentJSON({
                              ...props.charJSON,
                              json,
                            });
                            setOpenColorPickerBox(false);
                          }}
                          style={{ backgroundColor: lmc.color }}
                        >
                          <div
                            className="defaultColorsBlock"
                            style={{ visibility: "hidden" }}
                          >
                            abc
                          </div>
                        </div>
                      ))}

                    {props.value != undefined &&
                      props.value.name === "EyeBro" &&
                      SkinDefaultColors.map((lmc, index) => (
                        <div
                          onClick={(e) => {
                            var rgb = e.target.attributes.style.value
                              .split("(")[1]
                              .split(")")[0]
                              .split(",");
                            var json = props.charJSON;
                            localStorage.setItem("EyeBroColor", rgb);
                            setEyeBro(json, rgb);
                            props.setCurrentJSON({
                              ...props.charJSON,
                              json,
                            });
                            setOpenColorPickerBox(false);
                          }}
                          style={{ backgroundColor: lmc.color }}
                        >
                          <div
                            className="defaultColorsBlock"
                            style={{ visibility: "hidden" }}
                          >
                            abc
                          </div>
                        </div>
                      ))}

                    {props.value != undefined &&
                      props.value.name === "Glasses" &&
                      DefaultColors.map((lmc, index) => (
                        <div
                          onClick={(e) => {
                            var rgb = e.target.attributes.style.value
                              .split("(")[1]
                              .split(")")[0]
                              .split(",");
                            var json = props.charJSON;
                            localStorage.setItem("GlassColor", rgb);
                            setGlassesColor(json, rgb);
                            props.setCurrentJSON({
                              ...props.charJSON,
                              json,
                            });
                            setOpenColorPickerBox(false);
                          }}
                          style={{ backgroundColor: lmc.color }}
                        >
                          <div
                            className="defaultColorsBlock"
                            style={{ visibility: "hidden" }}
                          >
                            abc
                          </div>
                        </div>
                      ))}

                    {props.value != undefined &&
                      props.value.name === "Bottom" &&
                      DefaultColors.map((lmc, index) => (
                        <div
                          onClick={(e) => {
                            var rgb = e.target.attributes.style.value
                              .split("(")[1]
                              .split(")")[0]
                              .split(",");
                            var json = props.charJSON;
                            localStorage.setItem("BottomColor", rgb);
                            setBottomColor(json, rgb);
                            props.setCurrentJSON({
                              ...props.charJSON,
                              json,
                            });
                            setOpenColorPickerBox(false);
                          }}
                          style={{ backgroundColor: lmc.color }}
                        >
                          <div
                            className="defaultColorsBlock"
                            style={{ visibility: "hidden" }}
                          >
                            abc
                          </div>
                        </div>
                      ))}

                    {props.value != undefined &&
                      props.value.name === "Mustache" &&
                      SkinDefaultColors.map((lmc, index) => (
                        <div
                          onClick={(e) => {
                            var rgb = e.target.attributes.style.value
                              .split("(")[1]
                              .split(")")[0]
                              .split(",");
                            var json = props.charJSON;
                            localStorage.setItem("MustacheColor", rgb);
                            setMustache(json, rgb);
                            props.setCurrentJSON({
                              ...props.charJSON,
                              json,
                            });
                            setOpenColorPickerBox(false);
                          }}
                          style={{ backgroundColor: lmc.color }}
                        >
                          <div
                            className="defaultColorsBlock"
                            style={{ visibility: "hidden" }}
                          >
                            abc
                          </div>
                        </div>
                      ))}

                    {props.value != undefined &&
                      props.value.name === "Shoe" &&
                      DefaultColors.map((lmc, index) => (
                        <div
                          onClick={(e) => {
                            var rgb = e.target.attributes.style.value
                              .split("(")[1]
                              .split(")")[0]
                              .split(",");
                            var json = props.charJSON;
                            localStorage.setItem("ShoeColor", rgb);
                            setShoeColor(json, rgb);
                            props.setCurrentJSON({
                              ...props.charJSON,
                              json,
                            });
                            setOpenColorPickerBox(false);
                          }}
                          style={{ backgroundColor: lmc.color }}
                        >
                          <div
                            className="defaultColorsBlock"
                            style={{ visibility: "hidden" }}
                          >
                            abc
                          </div>
                        </div>
                      ))}

                    {props.value != undefined &&
                      props.value.name === "Beard" &&
                      SkinDefaultColors.map((lmc, index) => (
                        <div
                          onClick={(e) => {
                            var rgb = e.target.attributes.style.value
                              .split("(")[1]
                              .split(")")[0]
                              .split(",");
                            var json = props.charJSON;
                            localStorage.setItem("BeardColor", rgb);
                            setBeard(json, rgb);
                            props.setCurrentJSON({
                              ...props.charJSON,
                              json,
                            });
                            setOpenColorPickerBox(false);
                          }}
                          style={{ backgroundColor: lmc.color }}
                        >
                          <div
                            className="defaultColorsBlock"
                            style={{ visibility: "hidden" }}
                          >
                            abc
                          </div>
                        </div>
                      ))}

                    {props.value != undefined &&
                      props.value.name === "Cap" &&
                      DefaultColors.map((lmc, index) => (
                        <div
                          onClick={(e) => {
                            var rgb = e.target.attributes.style.value
                              .split("(")[1]
                              .split(")")[0]
                              .split(",");
                            var json = props.charJSON;
                            localStorage.setItem("CapColor", rgb);
                            setCapColor(json, rgb);
                            props.setCurrentJSON({
                              ...props.charJSON,
                              json,
                            });
                            setOpenColorPickerBox(false);
                          }}
                          style={{ backgroundColor: lmc.color }}
                        >
                          <div
                            className="defaultColorsBlock"
                            style={{ visibility: "hidden" }}
                          >
                            abc
                          </div>
                        </div>
                      ))}

                    {props.value != undefined &&
                      props.value.name === "Coat" &&
                      DefaultColors.map((lmc, index) => (
                        <div
                          onClick={(e) => {
                            var rgb = e.target.attributes.style.value
                              .split("(")[1]
                              .split(")")[0]
                              .split(",");
                            var json = props.charJSON;
                            localStorage.setItem("CoatColor", rgb);
                            setCoatColor(json, rgb);
                            props.setCurrentJSON({
                              ...props.charJSON,
                              json,
                            });
                            setOpenColorPickerBox(false);
                          }}
                          style={{ backgroundColor: lmc.color }}
                        >
                          <div
                            className="defaultColorsBlock"
                            style={{ visibility: "hidden" }}
                          >
                            abc
                          </div>
                        </div>
                      ))}

                    {props.value != undefined &&
                      props.value.name === "Mask" &&
                      DefaultColors.map((lmc, index) => (
                        <div
                          onClick={(e) => {
                            var rgb = e.target.attributes.style.value
                              .split("(")[1]
                              .split(")")[0]
                              .split(",");
                            var json = props.charJSON;
                            localStorage.setItem("MaskColor", rgb);
                            setMaskColor(json, rgb);
                            props.setCurrentJSON({
                              ...props.charJSON,
                              json,
                            });
                            setOpenColorPickerBox(false);
                          }}
                          style={{ backgroundColor: lmc.color }}
                        >
                          <div
                            className="defaultColorsBlock"
                            style={{ visibility: "hidden" }}
                          >
                            abc
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>

              <div className="boxUpper2">
                <div className="popTitle">Advance Colors</div>

                {!AdvanceColors && (
                  <span
                    className="material-icons"
                    style={{ padding: "3px 0px", cursor: "pointer" }}
                    //  onClick={close}
                    onClick={() => {
                      setAdvanceColors(true);
                    }}
                  >
                    expand_more
                  </span>
                )}

                {AdvanceColors && (
                  <span
                    className="material-icons"
                    style={{ padding: "3px 0px", cursor: "pointer" }}
                    //  onClick={close}
                    onClick={() => {
                      setAdvanceColors(false);
                    }}
                  >
                    expand_less
                  </span>
                )}
              </div>

              {props.value.name === "Hair" && AdvanceColors && (
                <div className="boxBottom">
                  <Chrome
                    color={rgba}
                    disableAlpha={true}
                    className="characterColor"
                  />
                </div>
              )}

              {props.value.name === "Eye" && AdvanceColors && (
                <div className="boxBottom">
                  <Chrome
                    color={rgba}
                    disableAlpha={true}
                    className="characterColor"
                  />
                </div>
              )}

              {props.TopActive === "Shirts" && AdvanceColors && (
                <div className="boxBottom">
                  <Chrome
                    color={rgba}
                    disableAlpha={true}
                    className="characterColor"
                  />
                </div>
              )}

              {props.TopActive === "Sweaters" && AdvanceColors && (
                <div className="boxBottom">
                  <Chrome
                    color={rgba}
                    disableAlpha={true}
                    className="characterColor"
                  />
                </div>
              )}

              {props.TopActive === "Jackets" && AdvanceColors && (
                <div className="boxBottom">
                  <Chrome
                    color={rgba}
                    disableAlpha={true}
                    className="characterColor"
                  />
                </div>
              )}

              {props.TopActive === "Bottoms" && AdvanceColors && (
                <div className="boxBottom">
                  <Chrome
                    color={rgba}
                    disableAlpha={true}
                    className="characterColor"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default SmartColorPicker;
